<script setup lang="ts">
import ResetComponent from '@/components/ResetComponent.vue';
import { useAgreementStore } from '@/stores/agreement';
import { useConfigStore } from '@/stores/config';
import { useCustomerStore } from '@/stores/customer';
import local from '@/stores/local';
import { useVehicleStore } from '@/stores/vehicle';
import { storeToRefs } from 'pinia';
import { computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute()
const agreementStore = useAgreementStore()
const vehicleStore = useVehicleStore()
const { savedCustomer } = storeToRefs(useCustomerStore())
const { config } = storeToRefs(useConfigStore())

const title = computed(() => route.query.manual === 'true' ? 'Din forespørgsel er nu sendt' : 'Din aftale er nu oprettet')

onMounted(() => {
  agreementStore.reset()
  vehicleStore.reset()
  local.clear()
})
</script>

<template>
  <v-container>
    <v-card :title="title">
      <v-card-text v-if="$route.query.manual === 'true'">
        <p>
          Du vil blive kontaktet snarest muligt af {{ config?.name ?? 'os' }} på {{ savedCustomer?.email ?? 'email' }}.
        </p>
      </v-card-text>
  
      <v-card-text v-else>
        <p>
          Din aftale er nu oprettet og du modtager en bekræftelses e-mail,
          der indeholder aftalebetingelserne og et link til oprettelse af
          betalingsmetode.
        </p>
        <p class="my-8">
          Din aftale er først aktiv, når du har klikket på linket, bekræftet
          aftalen og oprettet en betalingsmetode. Dine aftale vil herefter
          blive opkrævet i følge aftalen.
        </p>
        <p class="my-8">
          Bemærk at bekræftelses e-mailen kommer fra HOLCO der administrerer
          aftalen, fra afsender adressen sam@holco.dk. Hvis du ikke har
          modtaget bekræftelses e-mailen indenfor 30 minutter, så tjek din
          spam-/junk-mappe. Evt. kontakt forhandleren eller HOLCO.
        </p>
      </v-card-text>
    </v-card>

    <ResetComponent text="Lav ny aftale" class="mt-3" />
  </v-container>
</template>